interface SentryError extends Error {
    exOptions?: ErrorContext;
}

type SentryErrorLevel = 'info' | 'warning' | 'error';
interface ErrorContext {
    tags?: Array<string>;
    // @ts-ignore
    extra?: {[id: string]: {}};
    level?: SentryErrorLevel;
}

/**
 * This function should be used to provide an more accurate stack trace
 * for erros thrown in the global context
 * (e.g. a thrown in a setTimeout callback)
 */
export function getError(message: string, context?: ErrorContext): Error {
    try {
        const error: SentryError = new Error(message);
        if (context != null) {
            error.exOptions = context;
        }

        throw error;
    } catch (error) {
        return error;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/ErrorHelper.ts